import React, { PropsWithChildren, FC, memo } from 'react';
import { HumanizeOrdinalFormat } from 'shared/components/Format/HumanizeOrdinalFormat';

interface PrizePlaceFormatProps {
  places: number[];
}

const PrizePlaceFormatComponent: FC<PropsWithChildren<PrizePlaceFormatProps>> = ({ places }) => {
  if (!Array.isArray(places)) {
    return null;
  }

  if (places.length === 1) {
    return <HumanizeOrdinalFormat order={places[0]} />;
  }

  if (places.length > 1) {
    return (
      <>
        <HumanizeOrdinalFormat order={places[0]} />
        -
        <HumanizeOrdinalFormat order={places[places.length - 1]} />
      </>
    );
  }

  return null;
};

export const PrizePlaceFormat = memo(PrizePlaceFormatComponent);
